import { useCallback, useEffect, useMemo, useState } from 'react';
import { loadCardOrder, mergeCardOrder, reorderIds, saveCardOrder } from '../utils/cardOrder';

export function useCardOrder(storageKey, defaultIds) {
  const defaultKey = defaultIds.join('|');

  const [order, setOrderState] = useState(() => loadCardOrder(storageKey, defaultIds));

  useEffect(() => {
    setOrderState((prev) => mergeCardOrder(prev, defaultIds));
  }, [storageKey, defaultKey, defaultIds]);

  const setOrder = useCallback(
    (next) => {
      setOrderState((prev) => {
        const resolved = typeof next === 'function' ? next(prev) : next;
        saveCardOrder(storageKey, resolved);
        return resolved;
      });
    },
    [storageKey]
  );

  const moveCard = useCallback(
    (fromId, toId) => {
      setOrder((prev) => reorderIds(prev, fromId, toId));
    },
    [setOrder]
  );

  const resetOrder = useCallback(() => {
    setOrder([...defaultIds]);
  }, [defaultIds, setOrder]);

  const sortItems = useCallback(
    (items) => {
      const map = new Map(items.map((item) => [item.id, item]));
      return order.map((id) => map.get(id)).filter(Boolean);
    },
    [order]
  );

  return useMemo(
    () => ({ order, setOrder, moveCard, resetOrder, sortItems }),
    [order, setOrder, moveCard, resetOrder, sortItems]
  );
}
